import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dum-politica-privacidad',
  templateUrl: './politica-privacidad.component.html',
  styleUrls: ['./politica-privacidad.component.scss']
})
export class PoliticaPrivacidadComponent implements OnInit {

  contents: any[];
  constructor(
    private translateService: TranslateService
  ) { 
    this.contents = [
      { 
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.INTRODUCCION.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.INTRODUCCION.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.RESPONSABLE.TRATAMIENTO.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.RESPONSABLE.TRATAMIENTO.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.DATOS.PERSONALES.RECOPILADOS.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.DATOS.PERSONALES.RECOPILADOS.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.LIMITACIONES.TRATAMIENTO.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.LIMITACIONES.TRATAMIENTO.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.DESTINATARIOS.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.DESTINATARIOS.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.PLAZO.CONSERVACION.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.PLAZO.CONSERVACION.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.MEDIDA.SEGURIDAD.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.MEDIDA.SEGURIDAD.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.PRIVACIDAD.DERECHOS.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.PRIVACIDAD.DERECHOS.CUERPO')
      }
    ];

   }

  ngOnInit(): void {
  }

}
